<template>
 <main>
  <span class="kpquery">
   <i class="fas fa-search query-icon"></i>
   <input type="text" class="query-input" name="query" value="" placeholder="search through my entries">
   <button class="query-advanced" name="advancedQuery"><i class="fas fa-caret-down"></i></button>
   </span>
			<ul>
    <li v-for="(entry,i) in entries" :key="i">
     <router-link :to="'/journal/'+ entry.date +'/'+ entry.title +'/'+ entry.id">
      <span class="kpeTitle">{{entry.title}}</span>
      <span :class="[entry.dogear ? 'kpeDogear' : '']"></span>
      <span class="kpeDate" v-html="howLongAgo(entry.date)"></span>
     </router-link>
    </li>
			</ul>
  <!-- <span class="kpbranding"><a href="https://kitepen.com/" target="_blank">-built with KitePen-</a></span> -->
 </main>
</template>
<script>
import updateAvatarTitle from '@/lib/updateAvatarTitle';
export default {
 data(){
  return{
   loading:true,
   entries:[
    {id:1, title:'Designing SimpleMike.com', date:'2018-05-23T0800', dogear:true },
    {id:2, title:'Building KitePen', date:'2018-05-23T0800' },
    {id:3, title:'Reinventing the wheel', date:'2018-05-23T0800' }
   ]
  }
 },
 methods:{
  howLongAgo(d){
   return d;
  }
 },
 mounted(){
  updateAvatarTitle('Journal',this);
 }
}
</script>
<style lang="scss" scoped>
span.kpquery{
 width:100%;
 margin:0 auto;
 padding:0;
 display:grid;
 height:50px;
 grid-template-columns:50px auto 50px;
}
.query-icon{
 height: calc(100% - 2px);
 width:100%;
 margin:0;
 border-radius:8px 0 0 8px;
 display: flex;
 justify-content:center;
 align-items: center;
 border:1px solid #000;
 border-right:0px;
 font-size:30px;
 background-color: #FFF;
 color: #000;
}
input.query-input{
 border-radius:8px 0 0 8px;
 margin:0;
 padding:0 5px;
 text-align:right;
 font-family:Athiti;
 justify-self:center;
 width:calc(100% - 10px);
 border:1px solid #000;
 border-radius: 0px;
 border-right: 0px;
 border-left:0px;
 height: calc(100% - 2px);
 font-size: 1.5rem;
}
button.query-advanced{
 height:100%;
 width:100%;
 background-color:orange;
 margin:0;
 padding: 0;
 border-radius:0 8px 8px 0;
 justify-self:start;
 border:1px solid #000;
 border-left:0px;
 font-size:30px;
 color:#000;
}
span.kpbranding{
 text-align:center;
 display:block;
 a{
  font-family:inherit;
  text-decoration:none;
  font-size:1rem;
  color:#ccc;
	}
}
ul{
 list-style:none;
	padding:0;
}
ul li{
 background:rgba(0,0,0,0.10);
	border-radius:4px;
 &:not(:last-child){ margin-bottom:25px; }
	a{
  display:grid;
  width:calc(100% - 4px);
  margin:2px;
  color:#fff;
  font-size:1.2rem;
  text-decoration:none;
  grid-template-columns:auto auto;
  flex:0 1 auto;
  span.kpeTitle{
   grid-column-start:1;
   grid-column-end:3;
   grid-row-start: 1;
   grid-row-end: 2;
  }
  span.kpeDate{
   grid-column-start:2;
   grid-column-end:3;
   grid-row-start: 2;
   grid-row-end:3;
   justify-self:end;
   font-size:0.8rem;
  }
  span.kpeDogear{
   grid-column-start:1;
   grid-column-end:2;
   grid-row-start: 2;
   grid-row-end:3;
   justify-self:start;
   background-image:url(/lib/dogear.svg);
   background-repeat:no-repeat;
   background-position:0 0;
   width:17px;
   height:17px;
   align-self:end;
  }
 }
}
//mobile
@media screen and (max-width:666px){
 .kpeTitle{ font-size:1.2rem; }
 ul li a span.kpeDate{ font-size:1rem; }
}
</style>
